import tw, { styled } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';

export const StyledSection = styled.section<{
  hasHeroImage: boolean;
}>`
  ${tw`w-full`}
  ${tw`relative`}
  ${({ hasHeroImage }) => (hasHeroImage ? tw`mb-4 lg:mb-8` : tw`pb-[90px] mb-0`)}
  ${tw`bg-ui-colours-ui1`}
`;

export const StyledContainer = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`grid grid-cols-12`}
  ${tw`px-2 sm:px-0`}
`;

export const StyledHeadlineContainer = styled.div`
  ${tw`mt-4 md:mt-8`}
  ${tw`mb-[36px] md:mb-5`}
  ${tw`col-span-12 col-start-1 lg:col-span-8 lg:col-start-2`}
`;

export const StyledEyebrow = styled.p`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-primary-p1 text-tag-m uppercase`}
  ${tw`mb-2`}
`;

export const StyledHeadline = styled.h1`
  ${tw`text-secondary-s1 text-heading-m md:text-heading-l`}
  ${tw`font-poppins font-semi-bold`}
  ${tw`m-0`};
`;

export const StyledInfoContainer = styled.div`
  ${tw`flex flex-col gap-2`}
  ${tw`md:flex-row`}
  ${tw`w-full`}
  ${tw`mb-2 md:mb-[36px]`}

  ${tw`col-span-12 col-start-1 lg:col-span-10 lg:col-start-2`}
`;

export const StyledTag = styled.p`
  ${tw`text-neutrals-n7 text-tag-s`}
  ${tw`font-semi-bold`}
`;

export const StyledArticleInfo = styled.div`
  ${tw`flex flex-col justify-center`}
`;

export const StyledDate = styled.time`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-tag-l text-primary-p1`}
  ${tw`mb-[4px]`}
`;

export const StyledFigure = styled.figure`
  ${tw`w-full`}
  ${tw`col-span-12 col-start-1 lg:col-start-2 lg:col-span-10`}
`;

export const StyledImageElement = styled(ImageElement)`
  ${tw`w-full`}
  ${tw`m-0`}
  ${tw`rounded-xl`}
`;

export const StyledImagWrap = styled.div`
  ${tw`relative`}

  &:before {
    ${tw`content-['']`}
    ${tw`h-[75%] w-full`}
    ${tw`block`}
    ${tw`absolute left-0 bottom-0 `}
    ${tw`bg-neutrals-n1`}
  }
`;

export const StyledTagsList = styled.ul`
  ${tw`w-full`}
  ${tw`mb-5 md:mb-[47px]`}
  ${tw`col-span-12 col-start-1 lg:col-span-10 lg:col-start-2`}
  ${tw`flex flex-wrap gap-[10px] md:gap-2`}
`;
